import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  /**
   * Tracks concurrent HTTP requests (see {@link HttpErrorInterceptor}).
   * Without this, the first response calls `hide()` while other requests are still running.
   */
  private pendingHttpCount = 0;

  showLoader: BehaviorSubject<{ show: boolean }> = new BehaviorSubject<{
    show: boolean;
  }>({ show: false });

  constructor() { }

  show(): void {
    this.pendingHttpCount++;
    if (this.pendingHttpCount === 1) {
      this.showLoader.next({ show: true });
    }
  }

  hide(): void {
    this.pendingHttpCount = Math.max(0, this.pendingHttpCount - 1);
    if (this.pendingHttpCount === 0) {
      this.showLoader.next({ show: false });
    }
  }
}
